// src/pages/TaxpayerList.jsx
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import taxpayerService from "../../services/taxpayerService";
import { Button } from '@themesberg/react-bootstrap';

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";

const TaxpayerList = () => {
  const [users, setUsers] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const navigate = useNavigate();

  const fetchUsers = useCallback(async () => {
    try {
      const response = await taxpayerService.getAll();
      if (response.success && response.data.taxpayers) {
        setUsers(response.data.taxpayers);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleQuickFilter = (e) => {
    if (gridApi) {
      gridApi.setQuickFilter(e.target.value);
    }
  };

  const handleEdit = (id) => {
    navigate(`/taxpayers/${id}/edit`);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este usuario?")) return;
    try {
      await taxpayerService.deleteTaxpayer(id);
      fetchUsers(); // Refresh the list after deletion
    } catch (error) {
      console.error("Error al eliminar usuario:", error);
    }
  };

  const columnDefs = [
    { headerName: "Identificación", field: "profile.identification" },
    { headerName: "Nombre Comercial", field: "profile.comercial_name" },
    { headerName: "Correo", field: "email"  ,width: 230,},
    {
      headerName: "Activo",
      field: "is_active",
      width: 140,
      cellRenderer: (params) => (params.value ? "Sí" : "No"),
    },
    {
      headerName: "Acciones",
      field: "actions",
      width: 180,
      cellRenderer: (params) => (
        <div>
          <button
            onClick={() => handleEdit(params.data.id)}
            style={{ marginRight: "8px" }}
          >
            Editar
          </button>
          <button onClick={() => handleDelete(params.data.id)}>Eliminar</button>
        </div>
      ),
    },
  ];

  return (
    <div className="ag-theme-alpine" style={{ width: "100%", padding: "1rem" }}>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Usuarios</h4>
        <Button onClick={() => navigate("/taxpayers/create")}>Crear nuevo usuario</Button>
      </div>

      <div className="mb-3">
        <input
          type="text"
          placeholder="Buscar..."
          onChange={handleQuickFilter}
          className="form-control"
        />
      </div>

      <AgGridReact
        rowData={users}
        columnDefs={columnDefs}
        onGridReady={(params) => setGridApi(params.api)}
        domLayout="autoHeight"
        animateRows={true}
      />
    </div>
  );
};

export default TaxpayerList;
